<template>
  <v-main>
    <v-container>
      <v-card
        max-width="600"
        class="mx-auto mt-12"
        :class="$vuetify.breakpoint.smAndUp ? 'pa-10' : 'pa-4'"
      >
        <v-row align="center" no-gutters>
          <logo class="ml-4 mt-2"/> <p class="mb-0 mt-2 ml-2 helmi-navigation__title">
            HELMI
          </p><p
            class="mb-0 mt-2 helmi-navigation__title"
            :class="$vuetify.breakpoint.xs ? 'smaller ml-4' : 'ml-2'"
          >
            <template v-if="$vuetify.breakpoint.smAndUp">
              -
            </template>Allekirjoitusten aitoustarkistus
          </p>
        </v-row>
        <v-card-text v-if="!complete" class="pb-0">
          <p class="font-weight-bold mb-8 mt-2">
            Tarkista HELMI-kiinteistönvälitysjärjestelmässä allekirjoitetun asiakirjan aitous
            lisäämällä se alle. Syötä myös sähköpostiosoite, johon haluat tiedon asiakirjan
            aitoudesta.
          </p>

          <v-form
            ref="fileForm"
            v-model="fileFormValid"
          >
            <v-file-input
              v-model="file"
              outlined
              dense
              label="Tarkistettava tiedosto"
              :rules="[rules.required]"
              truncate-length="15"
            />

            <v-text-field
              v-model="email"
              outlined
              dense
              prepend-icon="mail"
              :rules="[rules.required, rules.email]"
              label="Sähköpostiosoite"
            />
          </v-form>
          <v-btn
            depressed
            color="primary"
            rounded
            @click="sendFile()"
          >
            Lähetä
          </v-btn>
        </v-card-text>
        <v-alert
          v-else
          type="success"
          text
          class="mt-4"
        >
          <b>Tiedoston lähetys onnistui!</b><br>
          Saat vahvistuksen allekirjoitusten aitoudesta 1-3 arkipäivän sisällä.
        </v-alert>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from 'axios';

export default {
  name: 'FileVerification',
  components: {
    logo: () => import('@/components/Icon'),
  },
  data: () => ({
    file: null,
    fileFormValid: false,
    uploading: false,
    complete: false,
    email: '',
    rules: {
      required: value => !!value || 'Pakollinen kenttä.',
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Virheellinen sähköpostiosoite.';
      },
    },
  }),
  methods: {
    async sendFile() {
      this.$refs.fileForm.validate();

      if (this.fileFormValid) {
        this.uploading = true;

        const formData = new FormData();

        formData.append('attachments[]', this.file);
        formData.append('email', this.email);
        formData.append('hash', this.$route.params.hash);

        await axios.post(process.env.NODE_ENV === 'production'
          ? '/public/backend/api/v1/attachments/verification/'
          : 'http://localhost:8888/public/backend/api/v1/attachments/verification/',
        formData,
        {
          withCredentials: true,
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        this.$refs.fileForm.reset();
        this.complete = true;
      }
    },
  },
};
</script>
<style scoped lang="scss">
* {
  font-family: 'Quicksand', sans-serif;
}

.smaller {
  font-size: 16px;
}
</style>
